var React = require('react');

function Like (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.30089 24.9999H6.12036C5.558 24.9999 5.01868 24.7786 4.62104 24.3848C4.22339 23.991 4 23.4568 4 22.8999V15.5499C4 14.993 4.22339 14.4588 4.62104 14.065C5.01868 13.6712 5.558 13.4499 6.12036 13.4499H9.30089M16.7221 11.35V7.14998C16.7221 6.31455 16.3871 5.51334 15.7906 4.92261C15.1941 4.33187 14.3851 4 13.5416 4L9.30089 13.4499V24.9999H21.2597C21.7711 25.0056 22.2673 24.8281 22.6569 24.5001C23.0466 24.1721 23.3034 23.7156 23.3801 23.2149L24.8431 13.7649C24.8892 13.464 24.8687 13.1567 24.783 12.8643C24.6973 12.572 24.5485 12.3016 24.3468 12.0718C24.1451 11.8421 23.8954 11.6586 23.615 11.5339C23.3345 11.4093 23.0301 11.3465 22.7228 11.35H16.7221Z","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Like.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Like;

Like.default = Like;
